import {
  MailOutlined,
  SettingOutlined,
  AppstoreOutlined,
  TeamOutlined,
  AimOutlined,
  CalendarOutlined,
  ShopOutlined,
  ClusterOutlined,
  EnvironmentOutlined,
  GlobalOutlined,
  DesktopOutlined,
  FileTextOutlined,
} from "@ant-design/icons";
import {
  Breadcrumb,
  Layout,
  Menu,
  Row,
  Col,
  Space,
  Button,
  Modal,
  Upload,
  Form,
  Input,
  Select,
  Divider,
  Avatar,
  message,
  notification,
  Tooltip,
  Card,
  Typography,
} from "antd";
import { BASE_URL,BASE_IMAGE_URL } from "../../service/apiConfig";

import { useNavigate } from "react-router-dom";
import React, { useEffect, useState } from "react";
import { Outlet } from "react-router-dom";
import Logo from "../../assets/logo_ct7.png";
import "./layoutmanagerment.css";
import adminService from "../../service/adminService";
import Login from "../../pages/login/index";
import homeIcon from "../../assets/homeIcon.png";
import dataIcon from "../../assets/iconData.png";
import { LoadingOutlined, PlusOutlined } from "@ant-design/icons";
import { useSelector } from "react-redux";
import { clearAdminProfile } from "../../features/adminAuthenRedux/adminAuthen";
import { useDispatch } from "react-redux";
import { Role } from "./roles";

const { Header, Content, Sider } = Layout;
const heightHeader = 92;
export default function LayoutMangement() {
  let navigate = useNavigate();
  const dispatch = useDispatch();

  const getItem = (label, key, icon, children, type) => {
    return {
      key,
      icon,
      children,
      label,
      type,
    };
  };
  const [form] = Form.useForm();
  const [currentRoleId, setCurrentRoleId] = useState(0);
  const [isSuperAdmin, setIsSuperAdmin] = useState(false);
  const [openProfile, setOpenProfile] = useState(false);
  const [adminId, setAdminId] = useState(0);
  const [profileData, setProfileData] = useState();
  const [imageUrl, setImageUrl] = useState("");
  const [loading, setLoading] = useState(false);
  const [invalidImage, setInvalidImage] = useState(false);
  const adminAuthen = useSelector((state) => state.adminAuthen);
  
  useEffect(() => {
    console.log(`Layout management effect`)
    const userData = adminAuthen.user
    if (userData != null) {      
      if (userData.role === Role.SuperAdmin) {
        setIsSuperAdmin(true);
        setAdminId(userData.id);
        setCurrentRoleId(userData.roleId);
        setProfileData(userData);
      }      
      setImageUrl(userData.avatar ?? '')
    }else{
      navigate('/management/login')
    }
  }, [adminAuthen.user]);

  const items = [
    {
      label: 'Quản lý',
      key: 'services',
      icon: <ClusterOutlined />,
      children: [
        getItem("Địa điểm Du lịch", "tour", <EnvironmentOutlined />),
        getItem("Sự Kiện", "event", <CalendarOutlined />),
        getItem("Loại Sự kiện", "eventCategory", <ShopOutlined />),
        getItem("Dịch vụ", "service", <AimOutlined />),        
        getItem("Loại Hình Dịch Vụ", "serviceCategory", <ShopOutlined />),        
        // getItem("Quảng cáo", "adsCategory", <ShopOutlined />),        
      ]
    },
    {
      label: 'Cấu hình',
      key: 'configs',
      icon: <SettingOutlined />,
      children: [
        getItem("Tỉnh Thành", "province", <GlobalOutlined />),
        getItem("Nhà cung cấp", "provider", <SettingOutlined />),
        getItem("Banners", "banners", <DesktopOutlined />),
        getItem("Nội dung", "contents", <FileTextOutlined />),
      ]
    },
    isSuperAdmin && getItem("Quản trị viên", "admin", <TeamOutlined />),
    isSuperAdmin && getItem("Người sử dụng", "users", <TeamOutlined />),
  ];

  const onClick = (e) => {
    console.log("click ", e);
    if (e.key === "tour") {
      navigate("/management/location-tour");
    }
    if (e.key === "service") {
      navigate("/management/location-service");
    }
    if (e.key === "event") {
      navigate("/management/event");
    }
    if (e.key === "user") {
      navigate("/management/user");
    }
    if (e.key === "serviceCategory") {
      navigate("/management/service-category");
    }
    // if (e.key === "adsCategory") {
    //   navigate("/management/ads-category");
    // }
    if (e.key === "eventCategory") {
      navigate("/management/event-category");
    }
    if (e.key === "admin") {
      navigate("/management/admin");
    }
    if (e.key === "users") {
      navigate("/management/users");
    }    
    if (e.key === "province") {
      navigate("/management/province");
    }
    if (e.key === "provider") {
      navigate("/management/provider");
    }
    if (e.key === "banners") {
      navigate("/management/banners");
    }
    if (e.key === "contents") {
      navigate("/management/contents");
    }
  };

  const itemsMenuheader = [
    {
      label: <a href="/"> Trang Chủ </a>,
      key: "mail",
      icon: <img src={homeIcon} alt="icon" />,
    },
    {
      label: <a href="#footer"> Nhập Liệu </a>,
      key: "app",
      icon: <img src={dataIcon} alt="icon" />,
    },
    // {
    //   label: <a href="/"> Tiếng Anh </a>,
    //   key: "SubMenu",
    // },
  ];

  const layout = {
    labelCol: { span: 8 },
    labelAlign: "left",
    wrapperCol: { span: 16 },
  };

  const onFinishAdmin = (value) => {
    value.avatar = imageUrl;
    value.roleId = currentRoleId;
    adminService.adminApi.updateAdmin(adminId, value).then((res) => {
      notification.success({ message: "Update profile success" });
      closeModalProfile();
      // getAllAdmin();
    });
  };
  const handleChange = async (info) => {
    if (!invalidImage) {
      if (info.file.status === "uploading") {
        setLoading(true);
        return;
      }
      if (info.file.status === "done") {
        // Get this url from response in real world.
        // getBase64(info.file.originFileObj, (url) => {
        //   setLoading(false);
        // });
        await setImageUrl(info.file.response.data.url);
        setLoading(false);
        console.log(123, info.file.response.data.url);
      }
    }
  };

  const beforeUpload = (file) => {
    const isJpgOrPng = file.type === "image/jpeg" || file.type === "image/png";

    if (!isJpgOrPng) {
      message.error("You can only upload JPG/PNG file!");
      setInvalidImage(true);
    } else {
      setInvalidImage(false);
    }

    const isLt2M = file.size / 1024 / 1024 < 2;

    return isJpgOrPng;
  };

  const onLogout = () => {
    adminService.AuthService.logout(adminAuthen.tokenData).then((result) => {
      console.log(`onLogout result ${JSON.stringify(result)}`)
      dispatch(clearAdminProfile())
    }).catch((e) => {
      dispatch(clearAdminProfile())
    })
  };

  const openModalProfile = () => {
    adminService.adminApi.getAdminById(adminId).then((res) => {
      setProfileData(res.data);
      form.setFieldsValue({
        userName: res.data.userName,
        email: res.data.email,
      });
      setImageUrl(res.data.avatar);
      setOpenProfile(true);
    });
  };

  const closeModalProfile = () => {
    setOpenProfile(false);
    form.setFieldsValue({ userName: "", email: "" });
  };
  
  const uploadButton = (
    <div>
      {loading ? <LoadingOutlined /> : <PlusOutlined />}
      <div
        style={{
          marginTop: 8,
        }}
      >
        Upload
      </div>
    </div>
  );

  return (
    <Layout style={{ minHeight: "100vh" }} className="layout-management">
      <Sider className="sider-left">
        <div className="logo" style={{ padding: 0, height: heightHeader }}>
          <img
            justifyContent="flex-start"
            src={Logo}
            style={{
              margin: 24,
              width: 70,
              height: 70,
            }}
            alt="Logo"
          />
        </div>
        <Menu
          onClick={onClick}
          defaultOpenKeys={['services', 'configs']}
          mode="inline"
          items={items}
          className="menu-slider"
        />
      </Sider>
      <Layout className="site-layout">
        <Header
          className="site-layout-background"
          style={{ padding: 0, height: heightHeader }}
        >
          <Row
            justify="end"
            style={{ marginRight: 24, height: "100%" }}
            align="middle"
          >
            <Space>
              <Menu
                mode="horizontal"
                items={itemsMenuheader}
                className="menu-managerment"
              />

              {/* <Button className="login" onClick={()=>{openModalProfile()}}>
                Profile
              </Button> */}
              {/* <Avatar
              style={{ marginTop:'15px'}}
                onClick={() => {
                  openModalProfile();
                }}
                size={64}
                icon={<UserOutlined />}
              /> */}
              <Tooltip
                color={"white"}
                placement="bottom"
                title={
                  <>
                    <Button
                      type={"primary"}
                      style={{ borderRadius: 10, width: "100px" }}
                      onClick={() => {
                        openModalProfile();
                      }}
                    >
                      Hồ Sơ
                    </Button>
                    <br />
                    <Button
                      type={"danger"}
                      style={{
                        borderRadius: 10,
                        width: "100px",
                        marginTop: "10px",
                      }}
                      onClick={() => {
                        onLogout();
                      }}
                    >
                      Đăng Xuất
                    </Button>
                  </>
                }
              >
                <Avatar size={34} style={{ backgroundColor: "#ff8c00", verticalAlign: 'middle' }} src={BASE_IMAGE_URL + imageUrl}><i className="fa fa-user"></i></Avatar>
              </Tooltip>
              <span>{profileData?.userName}</span>
            </Space>
          </Row>
        </Header>
        <Content style={{ margin: "16px" }}>
          <div
            className="site-layout-background"
            style={{ padding: 24, minHeight: 360 }}
          >
            <Outlet />
          </div>
        </Content>

        <Modal
          title={"Thông tin cá nhân"}
          visible={openProfile}
          onCancel={() => {
            // onCloseModalAdmin();
            // setAdminId(0);
            // setFileList([]);
            // form.setFieldsValue({ title: "" });
            setOpenProfile(false);
          }}
          // width="65%"
          footer={[
            <>
              <Button
                size="small"
                onClick={() => {
                  closeModalProfile();
                }}
              >
                Đóng
              </Button>
              <Button
                size="small"
                className="btn btn-primary"
                type="primary"
                form="CU-tour"
                key="submit"
                htmlType="submit"
              >
                Hoàn Thành
              </Button>
            </>,
          ]}
        >
          <Upload
            name="file"
            listType="picture-card"
            className="avatar-uploader"
            showUploadList={false}
            multiple={true}
            action={BASE_IMAGE_URL + "/api/upload"}
            beforeUpload={beforeUpload}
            onChange={handleChange}
            // fileList={fileList}
          >
            {/* {uploadButton} */}
            {imageUrl ? (
              <img
                src={BASE_IMAGE_URL + imageUrl}
                alt="avatar"
                style={{ width: "100%" }}
              />
            ) : (
              uploadButton
            )}
          </Upload>
          {/* //// */}
          <Form {...layout} form={form} name="CU-tour" onFinish={onFinishAdmin}>
            <Form.Item
              name="userName"
              label="Tên tài khoản"
              rules={[{ required: true }]}
            >
              <Input />
            </Form.Item>
            <Form.Item name="email" label="Email" rules={[{ required: true }]}>
              <Input disabled />
            </Form.Item>

            <Divider plain style={{ color: "darkgray" }}>
              Để trống phần bên dưới nếu bạn không thay đổi mật khẩu
            </Divider>

            <Form.Item
              name="password"
              label="Mật khẩu"
              rules={[{ required: adminId != 0 ? false : true }]}
            >
              <Input.Password />
            </Form.Item>
            <Form.Item
              name="confirmPassword"
              label="Xác nhận mật khẩu"
              rules={[
                { required: adminId != 0 ? false : true },
                ({ getFieldValue }) => ({
                  validator(_, value) {
                    if (!value || getFieldValue("password") === value) {
                      return Promise.resolve();
                    }
                    return Promise.reject(
                      new Error(
                        "The two passwords that you entered do not match!"
                      )
                    );
                  },
                }),
              ]}
              dependencies={["password"]}
            >
              <Input.Password />
            </Form.Item>
          </Form>
          {/* //// */}
        </Modal>
      </Layout>
    </Layout>
  );
}
